import { render } from "./PolandMap.vue?vue&type=template&id=22027b6b&scoped=true"
import script from "./PolandMap.vue?vue&type=script&lang=js"
export * from "./PolandMap.vue?vue&type=script&lang=js"

import "./PolandMap.vue?vue&type=style&index=0&id=22027b6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22027b6b"]])

export default __exports__